import { Icons, Modal, Typography } from '@pankod/refine-antd'
import React from 'react'

const { ExclamationCircleTwoTone } = Icons

interface PopupModalProps {
  visible: boolean
  close: () => void
  title: string
  confirm: () => void
}

const PopupModal: React.FC<PopupModalProps> = ({ visible, close, title, confirm }) => {
  return (
    <Modal title={null} visible={visible} onOk={confirm} onCancel={close} okText="Yes,Confirm" cancelText="Cancel">
      <Typography.Title level={4}>
        <ExclamationCircleTwoTone /> {title}
      </Typography.Title>
    </Modal>
  )
}

export default PopupModal
